<template>
  <div class="hero-video">
    <div class="container">
      <div class="hero-video-section">
        <div class="video-block__title">
          <h1 class="focus-page__title">{{ video.title }}</h1>
          <div class="border-bottom"></div>
        </div>
        <div class="video-embed" v-html="video.embed_link">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroVideoComponent',
  props: ["video"]
}
</script>
